// eligibilityCopy.js — L1 step 5b (TEST 3.05): the patient-facing eligibility copy, in the
// patient's language when the API sent it.
//
// ★★ THE API'S SHAPE (orella-api v243.268.0, rcm_service._apply_result_messages): every
//   eligibility result carries the English `headline` / `patientMessage`, and beside them
//   `headlineEs` / `patientMessageEs` — set for the classes ELIGIBILITY_MESSAGES_ES lists
//   (payer_unreachable and unknown today), null for every other class. A client shows the
//   Spanish for an es locale and falls back to the English for a class with no Spanish.
//   No other locale has API copy, so every other language reads the English, as before.
//
// No imports on purpose: gates import this file directly under plain node.

const usable = (v) => typeof v === 'string' && v.trim() !== ''

/** { headline, body } for one eligibility result in `language`; null where the API sent none. */
export function eligibilityCopy(eligibility, language) {
  const e = eligibility || {}
  const es = language === 'es'
  const pick = (en, esText) => (es && usable(esText) ? esText : (usable(en) ? en : null))
  return { headline: pick(e.headline, e.headlineEs), body: pick(e.patientMessage, e.patientMessageEs) }
}
